import Api from '@/api/api.js'

export default {
    getExamens() {
        const promise = Api().get('/type_examens')
        return promise.then(response => response.data)
    },

    saveDemandeExamen(data) {
        const promise = Api().post('/examens/save_demande', data)
        return promise.then((response) => response.data)
    },

    editExamenRenseignementClinique(data) {
        const promise = Api().post('/examens/bulletin/edit-renseignement-clinique', data)
        return promise.then((response) => response.data)
    },

    getDemandeExamen(data) {
        const promise = Api().get('/examens/'+data.consultation_id+'/demandes')
        return promise.then(response => response.data)
    },

    deleteDemandeExamen(data) {
        const promise = Api().post('/examens/delete/demande-examen', data)
        return promise.then((response) => response.data)
    },

    deleteExamenBulletin(data) {
        const promise = Api().post('/examens/delete/bulletin-examen', data)
        return promise.then((response) => response.data)
    },

    /**
     * Ajouter un nouveau type d'examen paraclinique
     * @param {*} data 
     * @returns 
     */
    addNewExamen(data) {
        const promise = Api().post('/examens/type_examen/store', data)
        return promise.then((response) => response.data)
    },

    searchExamen(keyword){
        const promise = Api().get('type_examens/search?search_word='+keyword)
        return promise.then((response) => response.data)
    },

    getExamensMiniInfo(){
        const promise = Api().get('type_examens?mini=1')
        return promise.then((response) => response.data)
    },

    saveResultatExamen(data) {
        const promise = Api().post('/examens/store/resultat', data)
        return promise.then((response) => response.data)
    },

    getRegistreExamen(user_id) { 
        const promise = Api().get('consultations/salle_examen/user/'+user_id+'/registre')
        return promise.then((response) => response.data)
    },

    getExamenToFill(data) { 
        const promise = Api().post('consultations/examen/remplir', data)
        return promise.then((response) => response.data)
    },

    getExamenSalleAttente(data) { 
        const promise = Api().post('examens/demande-en-attente', data)
        return promise.then((response) => response.data)
    },

    deleteTypeExamen(data) { 
        const promise = Api().post('examens/type_examen/delete', data)
        return promise.then((response) => response.data)
    },

    getBulletinExamen(data) { 
        const promise = Api().post('examens/bulletin/liste-examens', data)
        return promise.then((response) => response.data)
    },

    getExamensAttenteInterpretation(data) { 
        const promise = Api().post('examens/attentes-interpretation', data)
        return promise.then((response) => response.data)
    },

    saveExamenInterpretation(data) { 
        const promise = Api().post('examens/store-interpretation', data)
        return promise.then((response) => response.data)
    },

    getHistoriqueResultatExamen(data) { 
        const promise = Api().post('examens/get-recap-info/resultat-historique', data)
        return promise.then((response) => response.data)
    },

    saveClicheExamen(data) { 
        const promise = Api().post('examens/edit-cliche', data)
        return promise.then((response) => response.data)
    },

    
}